/** @jsx isolateComponent */

import { isolateComponent, labelStyles } from '@zapier/common-utils';
import { Icon, Text, Colors } from '@zapier/design-system';
import { css } from '@emotion/core';

import Link from 'app/common/components/Link';
import { HELP_CENTER } from 'app/developer-v3/teams/team-technical-support-operations/get-help';

const Styles = labelStyles(__filename, {
  container: css`
    background-color: ${Colors.Yellow1};
    border-radius: 8px;
    padding: 20px;
    margin-top: 0;
  `,
  title: css`
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-template-columns: 20px 1fr;
    grid-column-gap: 10px;
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;
  `,
  body: css`
    margin-left: 30px;
  `,
  link: css`
    font-weight: 500;
  `,
});

export const ContactUs = () => {
  return (
    <div css={Styles.container}>
      <div css={Styles.title}>
        <Icon name="navHelpFill" size={20} />
        <Text>
          Need help with your Zapier account, Zaps, or have a general question
          about Zapier?
        </Text>
      </div>
      <div css={Styles.body}>
        <Text tag="p">
          Visit the main Zapier{' '}
          <Link css={Styles.link} href={HELP_CENTER} target="_blank">
            Help Center
          </Link>{' '}
          for help with building and troubleshooting your Zaps.
        </Text>
      </div>
    </div>
  );
};
